import { userReducer } from './userReducer';
import { combineReducers } from 'redux';
import { appInfoReducer } from './appInfoReducer';
import { notificationReducer } from './notificationReducer';
import { productReducer } from './productReducer';

export const allReducers = combineReducers({
    userInfo: userReducer,
    appInfo: appInfoReducer,
    notification: notificationReducer,
    productInfo: productReducer
})